/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'

interface Props {
  title?: string
  labelValue?: string
  active: boolean
  icon: string
  backgroundColor?: string
  activeColor?: string
  inactiveColor?: string
}

const IconLabelContent: FC<Props> = ({
  title = '',
  labelValue,
  active,
  icon,
  backgroundColor = 'bg-gray-100',
  activeColor = 'text-primary',
  inactiveColor = 'text-gray-500',
}) => {
  const iconClasses = `fs-7 ${icon} ${active ? activeColor : inactiveColor}`
  const backgroundClasses = `border badge me-1 ${backgroundColor}`
  const labelClasses = `fs-6 me-1 ${active ? activeColor : inactiveColor}`

  return (
    <span className={backgroundClasses} title={title}>
      <div className='d-flex flex-row justify-content-start align-items-center'>
        {labelValue && <span className={labelClasses}>{labelValue}</span>}
        <i className={iconClasses} />
      </div>
    </span>
  )
}

export {IconLabelContent}
